((Drupal, once) => {
  function addLoader(input) {
    // Find the parent element and add a class to it.
    const parent = input.closest(".is-search-open");
    // Add a class to the parent element to indicate loading state.
    if (parent) {
      parent.classList.add("is-search-loading");
    }
  }

  Drupal.behaviors.headerSearch = {
    attach: (context) => {
      once("tfal-header-search", ".navbar-nav .btn-search", context).forEach(
        (search) => {
          // Guard against double-binding within the same element.
          if (search.dataset.headerSearchBound === "true") {
            return;
          }
          search.dataset.headerSearchBound = "true";

          const OPEN_CLASS = "is-search-open";

          const ensureInput = () => {
            let searchInput = search.querySelector("input.search-input");
            if (!searchInput) {
              searchInput = document.createElement("input");
              searchInput.type = "text";
              searchInput.name = "keywords";
              searchInput.placeholder = "Keywords";
              searchInput.classList.add(
                "form-control",
                "search-input",
                "form-text"
              );
              search.appendChild(searchInput);
            }
            let searchIcon = search.querySelector(".btn-search");
            if (!searchIcon) {
              searchIcon = document.createElement("button");
              searchIcon.type = "submit";
              searchIcon.classList.add(
                "btn",
                "btn-link",
                "link-dark",
                "d-flex",
                "text-decoration-none",
                "shadow-none",
                "p-0",
                "btn-search",
                "position-absolute",
                "me-3"
              );
              search.appendChild(searchIcon);
            }
            return searchInput;
          };

          const open = () => {
            const input = ensureInput();
            // Toggle class in the next frame so the browser registers the
            // initial (hidden) styles before applying the open state.
            requestAnimationFrame(() => {
              search.classList.add(OPEN_CLASS);
              input.focus();
            });
          };

          const close = () => {
            const input = search.querySelector("input.search-input");
            const searchIcon = search.querySelector(".btn-search");
            if (!input) return;

            // Start the CSS transition.
            search.classList.remove(OPEN_CLASS);

            // Remove after transition ends (or quickly if transition doesn't fire).
            const remove = () => {
              if (input.parentNode === search) {
                search.removeChild(input);
                search.removeChild(searchIcon);
              }
              input.removeEventListener("transitionend", onTransitionEnd);
            };

            const onTransitionEnd = (e) => {
              if (
                e.propertyName === "transform" ||
                e.propertyName === "opacity"
              ) {
                remove();
              }
            };

            input.addEventListener("transitionend", onTransitionEnd);
            window.setTimeout(remove, 250);
          };

          search.addEventListener("click", (e) => {
            // If this is a link, prevent navigation so we can open the input.
            e.preventDefault();

            // If the click is on the input, do nothing (e.g. allow user to select text).
            if (e.target.matches("input.search-input")) {
              return;
            }

            // If the click is on the search button, act as if the user submitted on Enter.
            // A loader is displayed in the input when the user clicks the search button or click enter.
            if (e.target.matches("button.btn-search")) {
              const input = search.querySelector("input.search-input");
              if (!input) return;

              e.preventDefault();
              const url = new URL(search.href);
              url.searchParams.set("keywords", input.value);
              window.location.href = url.toString();

              addLoader(search);
              return;
            }

            // Toggle.
            if (search.classList.contains(OPEN_CLASS)) {
              close();
            } else {
              open();
            }
          });

          // Submit on Enter.
          search.addEventListener("keydown", (e) => {
            if (e.key !== "Enter") return;
            const input = search.querySelector("input.search-input");
            if (!input) return;

            e.preventDefault();
            const url = new URL(search.href);
            url.searchParams.set("keywords", input.value);
            window.location.href = url.toString();

            addLoader(search);
          });

          // Close on outside click.
          document.addEventListener("click", (e) => {
            if (!search.classList.contains(OPEN_CLASS)) return;
            if (!search.contains(e.target)) {
              close();
            }
          });

          // Close on Escape.
          document.addEventListener("keydown", (e) => {
            if (e.key === "Escape" && search.classList.contains(OPEN_CLASS)) {
              close();
            }
          });
        }
      );
    },
  };
})(Drupal, once);
